window.addEventListener("load", () => {
  const loadingOverlay = document.querySelector(".l-loading-overlay");
  const loadingContents = document.querySelector(".l-loading-contents");
  const loading = document.querySelector(".l-loading");

  const local = localStorage.setItem('key', 'value');

  if (loadingOverlay) {
    loadingOverlay.classList.add("-is-open");
    if (loadingOverlay.classList.contains("-is-open")) {
      loadingContents.classList.add("-is-close");
      setTimeout(() => {
        loading.style.zIndex = 1;
      }, 5000);
    }

  }
});
